export default "__VITE_ASSET__nG_ac9m0__"